export default __webpack_public_path__ + "static/media/WINE1.815cd0b5.jpg";